
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/security/azure",
      function () {
        return require("private-next-pages/security/azure/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/security/azure"])
      });
    }
  